import { LoginResponse } from 'features/sign-in/types/login-response'
import apiService from './api.service'
import apiConfig from './api.config'
import tokenService from './token.service'
import { ApiResponse } from '../types/api-response'

interface LoginCredentials {
  username: string
  password: string
}

class AuthService {
  /**
   * Login user with email and password
   */
  public async login(
    credentials: LoginCredentials
  ): Promise<ApiResponse<LoginResponse>> {
    const response = await apiService.post<ApiResponse<LoginResponse>>(
      apiConfig.endpoints.auth.login,
      credentials
    )
    return response
  }

  /**
   * Logout user
   */
  public logout(): void {
    tokenService.clearTokens()
  }

  public storeLoginData(loginData: LoginResponse): void {
    tokenService.setTokens(loginData.accessToken, loginData.refreshToken, 30)
    tokenService.setUserData(loginData.user)
  }
}

export const authService = new AuthService()
export default authService
